export default __webpack_public_path__ + "static/media/TopoExample.4ffaf046.png";